import { Form, Formik } from "formik";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";

export default function RemoveOptOutsDialog({
  open,
  onClose,
  onSubmit
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
}): JSX.Element {
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Clear all opt-outs from the Do-Not-Call list
        </DialogTitle>
        <Formik onSubmit={onSubmit} initialValues={{}}>
          {({ isSubmitting }) => (
            <Form>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <Alert severity="warning">
                    <strong>Warning:</strong> This action will clear all
                    opt-outs for this organization. This includes all opt-opts
                    previously uploaded and any opt-outs recorded in your
                    surveys.
                    <br />
                    <br />
                    Only perform this action if you are able to rebuild your
                    Do-Not-Call list from another system and re-upload it.
                  </Alert>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    void onSubmit();
                  }}
                  color="primary"
                  type="submit"
                  disabled={isSubmitting}
                  variant="contained"
                  autoFocus
                >
                  {isSubmitting ? "Starting clearing..." : "Clear list"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </>
  );
}
